import React from 'react';
import errorController from 'Components/ErrorScreens';
import RouteLoading from 'Components/RouteLoading';
import _ from 'lodash';

import useGetSingleListAndSetBreadcrumb from '../hooks/useGetSingleListAndSetBreadcrumb';
import Uploader from './components/Uploader';
import { UploaderProvider } from './components/Uploader/context/uploader-context';

function ListEntryBulkUpload() {
    const { listId, query: singleListAPI } = useGetSingleListAndSetBreadcrumb();
    const { hasError, errorCmp } = errorController([singleListAPI.error]);

    if (singleListAPI.isLoading) {
        return <RouteLoading />;
    }

    if (hasError || !singleListAPI.data || _.isEmpty(singleListAPI.data)) return errorCmp;
    const listType = singleListAPI.data.listType as SingleListType;
    return (
        <UploaderProvider
            listProps={{
                listName: singleListAPI.data.name,
                listType,
                listId,
                merchantSpecific: singleListAPI.data.merchantSpecific,
                customListType: singleListAPI.data.customListType
            }}
        >
            <Uploader />
        </UploaderProvider>
    );
}

export default ListEntryBulkUpload;
